import moment from 'moment-timezone';
import jstz from 'jstimezonedetect';

export function getTimeZone() {
  return jstz.determine().name();
}

export function getURIEncodedTimeZone() {
  return encodeURIComponent(getTimeZone());
}

export function getUtcOffset() {
  return moment().utcOffset();
}

const elements = {
  getTimeZone,
  getURIEncodedTimeZone,
  getUtcOffset
};

export default elements;
